import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@img/icon-gem.png'
import _imports_1 from '@img/btn-recharge.png'
import _imports_2 from '@img/icon-position.png'


const _withScopeId = n => (_pushScopeId("data-v-708a6776"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "payment"
}
const _hoisted_2 = {
  key: 0,
  class: "buy-good-header"
}
const _hoisted_3 = { class: "img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "good-name ellipsis2" }
const _hoisted_7 = { class: "price-info" }
const _hoisted_8 = { class: "price" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "or" }, "or", -1))
const _hoisted_10 = { class: "gem" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "left" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_14 = { class: "right" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "left" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 3,
  class: "third-pay-box",
  ref: "thirdPayBoxDom"
}
const _hoisted_19 = { class: "title-box" }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "location" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_23 = { class: "country-list" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "payment-name" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popover = _resolveComponent("Popover")!

  return (_ctx.paymentData?.goodsInfo?.goodsId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.kind !== _ctx.GoodsPaymentWayKind.GPWK_Recharge)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _ctx.paymentData.goodsInfo?.goodsIcon,
                  alt: ""
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.paymentData.goodsInfo.goodsName), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, "$ " + _toDisplayString(_ctx.paymentData.goodsInfo.price), 1),
                  (_ctx.paymentData.gemPay)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createTextVNode(" " + _toDisplayString(_ctx.paymentData.gemPay.amount), 1)
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.paymentData.gemPay)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["gems-pay-box", {
        active: _ctx.isSelectGemPay,
      }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectPayment('gemPay', _ctx.paymentData.gemPay?.thirdPaymentWayId)))
            }, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("Payment.gemsPay")), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.isEnoughWhenSelectGemPay)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("Payment.balance")) + ": " + _toDisplayString(_ctx.loginStore.gems), 1))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("Payment.recharge")), 1),
                      _createElementVNode("img", {
                        src: _imports_1,
                        alt: "",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('gotoRecharge')), ["stop"]))
                      })
                    ], 64))
              ])
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.paymentData.googlePay)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["google-pay-box", {
          active: _ctx.isSelectGooglePay,
        }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectPayment('googlePay', _ctx.paymentData.googlePayWay!)))
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("img", {
                  src: require('@/assets/img/icon-google.svg'),
                  alt: ""
                }, null, 8, _hoisted_17),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("Payment.googlePay")), 1)
              ])
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.paymentData.thirdPaymentPlatformList?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("Payment.localPaymentMethod")), 1),
                _createVNode(_component_Popover, {
                  trigger: "hover",
                  placement: "bottom",
                  overlayClassName: "payment-popover",
                  color: "#292929",
                  zIndex: 3000
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentData.thirdPaymentPlatformList[0]
                  .countryWayList, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["item", {
                  active:
                    _ctx.getSelectPaymentCountryName === item.paymentCountryName,
                }]),
                          key: item.paymentCountryName,
                          onClick: ($event: any) => (_ctx.changeCountryPayment(item))
                        }, _toDisplayString(item.paymentCountryName), 11, _hoisted_24))
                      }), 128))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("span", null, _toDisplayString(_ctx.getSelectPaymentCountryName), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["select-country-third-payment", { scroll: _ctx.getSelectThirdPayment.length > 3 }]),
                ref: "selectCountryThirdPaymentDom"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSelectThirdPayment, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["item", {
            active:
              _ctx.selectPaymentType === 'thirdPay' &&
              _ctx.selectPaymentTypeId === item.thirdPaymentWayId,
          }]),
                    key: item.thirdPaymentWayId,
                    onClick: ($event: any) => (_ctx.selectPayment('thirdPay', item))
                  }, [
                    _createElementVNode("img", {
                      src: item.paymentIcon,
                      alt: ""
                    }, null, 8, _hoisted_26),
                    _createElementVNode("span", _hoisted_27, _toDisplayString(item.paymentName), 1)
                  ], 10, _hoisted_25))
                }), 128))
              ], 2)
            ], 512))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "pay-btn",
          title: "buy",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.orderGoods && _ctx.orderGoods(...args)))
        }, [
          (_ctx.isSelectGemPay)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_28,
                _createTextVNode(" " + _toDisplayString(_ctx.paymentData.gemPay.amount), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("USD " + _toDisplayString(_ctx.paymentData.goodsInfo.price) + " Buy", 1)
              ], 64))
        ])
      ]))
    : _createCommentVNode("", true)
}